/* ═══════════════════════════════════════════════════
   TrackLab v2 — Public API (Trampolines) & Init
   Loaded LAST — bridges TL.* to window.v2* for
   inline onclick handlers in Django templates.
   ═══════════════════════════════════════════════════ */

(function () {
  'use strict';

  // ── View switching ──
  window.v2ShowRace = function (id) { TL.views.showRace(id); };
  window.v2ShowList = function () { TL.views.showList(); };
  window.v2ToggleOverflow = function (id, n) { TL.views.toggleOverflow(id, n); };
  window.v2SwitchDay = function (idx) { TL.views.switchDay(idx); };
  window.v2ToggleUpcomingRace = function (id) { TL.views.toggleUpcomingRace(id); };
  window.v2ToggleLiveBanner = function (id) { TL.views.toggleLiveBanner(id); };

  // ── Runner selection ──
  window.v2SelectRunner = function (el, id) { TL.runner.selectRunner(el, id); };

  // ── Betting ──
  window.v2OpenBetPanel = function () { TL.betting.openPanel(); };
  window.v2CloseBetPanel = function () { TL.betting.closePanel(); };
  window.v2PickAmt = function (btn, amt) { TL.betting.pickAmt(btn, amt); };
  window.v2PickType = function (btn, type) { TL.betting.pickType(btn, type); };

  // ── Venue filter ──
  window.v2FilterVenue = function (btn) { TL.venue.filter(btn); };

  // ── Results ──
  window.v2ToggleStats = function (el) { TL.results.toggleStats(el); };
  window.v2ToggleResult = function (card) { TL.results.toggleResult(card); };
  window.v2SelectResult = function (el, id) { TL.results.selectResult(el, id); };

  // ── Init ──
  if (TL.results && TL.results.initRings) TL.results.initRings();

  // Restore expanded race from URL hash (back-button support)
  TL.views.restoreFromHash();

  // Also restore on back/forward navigation (bfcache + popstate)
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) TL.views.restoreFromHash();
  });
  window.addEventListener('popstate', function () {
    TL.views.restoreFromHash();
  });

  // Delegate all live page lifecycle to schedule module
  if (TL.schedule) {
    TL.schedule.init();
  } else {
    // Fallback for non-live pages (upcoming, results) that don't need schedule
    TL.countdown.update();
  }
})();
